<template>
    <tbody>
        <tr 
            v-for="(row, i) in items"
            :key="i"
        >               
            <!-- <td class="pr-3">                
                <v-simple-checkbox 
                    color="generalCheckbox" 
                    :value="isSelected" 
                    @input="select($event)"
                ></v-simple-checkbox>                
            </td> -->
            <td> {{ row.category }}</td>
            <td> {{ row.fileName }}</td>
            <!-- v-if="row.editable" -->
            <td>
                <ValidationProvider
                    v-slot="{ errors }"
                    rules="prolistYear"
                    slim
                >
                    <v-text-field         
                        v-model="row.year"
                        :error="row.yearError"
                        depressed
                        hide-details 
                        class="alvcell mt-0 pt-1"
                        reverse      
                        :error-messages="errors"     
                    ></v-text-field>
                </ValidationProvider>
                <!-- <template v-else>
                    {{ row.year }}
                </template> -->
            </td>
            <td class="text-right">{{ row.rows }}</td>
            <td>{{ $d(new Date(row.importDate), 'alvDateFormat', selectedDateFormat) }}</td>

            <!-- Buttons -->
            <!-- Download Button -->
            <td>
                <BaseIcon 
                    v-if="row.path !== null"
                    :href="row.path"
                    icon="cloud_download"
                    tooltipText="lang_GENERAL_CAPTION_ICON_DOWNLOAD"
                />        
            </td>

            <!-- Delete -->
            <td>
                <BaseIcon 
                    v-if="!row.editable" 
                    @click="deleteRow(row)"
                    icon="delete"
                />
            </td>                                
        </tr> 
    </tbody>
</template>

<script>
import BaseIcon from '@/components/_buttons/BaseIcon'
import { validate } from 'vee-validate'

export default {
    name: "ProlistsEditRow",
    components: {
        BaseIcon
    },
    props: {
        items: {
            required: true,
            type: Array,
            default: []
        }
    },
    computed: {
        noDataText() { return this.$store.getters.getNoDataText },
        selectedDateFormat() { return this.$i18n.locale },
    },
    methods: {
        edit(row) {
            this.$store.commit('setProlistsTempRow', row)
            row.editable = !row.editable
        },
        async save(row) {
            await validate(row.year, 'required').then(result => {
                row.yearError = !result.valid
            })

            await this.$nextTick() 
            
            if(row.yearError) {
                this.$store.commit('setSnackbar', {
                    type: 'error',
                    msg: "Year for statement is missing"
                })
            } else {
                this.$store.commit('deleteProlistsTempRow', row)
                // TODO API CALL for saving
                row.editable = !row.editable
            }                        
            
        },
        deleteRow(row) {
            this.$store.commit('setSelectedProlists', [row.id])
            this.$store.commit('setShowDeletionDialogProlists', true)
        },
        cancel(row) {
            this.$store.commit('replaceNewProlistsValuesWithOld', row)
            this.$store.commit('deleteProlistsTempRow', row)
        }
    }
}
</script>